import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7443f581"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "productcard" }
const _hoisted_2 = {
  key: 0,
  class: "offerPrice"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "productInfos" }
const _hoisted_5 = {
  key: 0,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "priceContainer"
}
const _hoisted_8 = {
  key: 0,
  class: "newPrice"
}
const _hoisted_9 = {
  key: 1,
  class: "newPrice"
}
const _hoisted_10 = {
  key: 2,
  class: "oldPrice"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "productInfos" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 2,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_18 = {
  class: "productInfos placeHolder",
  style: {"visibility":"hidden"}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  key: 0,
  class: "cardActions"
}
const _hoisted_24 = {
  key: 1,
  style: {"font-size":"30px"}
}
const _hoisted_25 = {
  key: 1,
  style: {"font-size":"30px"}
}

import SvgThumbDown from '@/components/svg/ThumbDown.vue'
import SvgThumbUp from '@/components/svg/ThumbUp.vue'
import FeedbackOverlay from './FeedbackOverlay.vue';
import Location from '@/components/svg/Location.vue';
import Cutlery from '@/components/svg/Cutlery.vue';
import Favorite from '@/components/svg/Heart.vue';
import { Product } from '@/entities/domain/Match/Product';
import Company from '@/entities/domain/Company/Company';
import { StylingVariant, ResultButtonAction } from '@/entities/enums/QuizConfigEnums';
import { ProductFeedbackCause } from '@/entities/enums/ProductFeedbackCause';
import QuizService from '@/services/QuizService';
import { PropType, computed, ref, onMounted, watch, nextTick } from 'vue'
import { mount } from '@vue/test-utils';



export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardV2',
  props: {
    company: {
        type: Object as PropType<Company>,
        required: true,
    },
    product: {
        type: Object as PropType<Product>,
        required: true,
    },
    stylingVariant: {
        type: String as PropType<StylingVariant>,
        default: StylingVariant.NORMAL,
    },
    showOfferMode: {
        type: Boolean,
        default: false,
    },
    isCardFlipped: {
        type: Boolean,
        default: false,
    }
},
  emits: ["productImageClicked", "productClicked", "productFeedbackCauseSelected"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const isFeedbackOverlayVisible = ref(false);
const favorite = ref(false);
const dislike = ref(false);
const isCardFlippedInner = ref((props.isCardFlipped && (props.product.Country || props.product.Region || props.product.Description || props.product.TasteMatch || props.product.FoodRecommendation)) as boolean);
const showDescriptionPopUp = ref(false);

const flip = () => {
    if (!props.product.Country && !props.product.Region && !props.product.Description && (!props.product.TasteMatch || !props.company.CompanyQuizConfig.ShowMatchingPercentage) && !props.product.FoodRecommendation)
        return;

    isCardFlippedInner.value = !isCardFlippedInner.value;
}

// watch props isCardFlipped
watch(() => props.isCardFlipped, (newValue) => {
    isCardFlippedInner.value = newValue;
})

const description = computed(() => {
    if (props.product?.Description && props.product.Description.length > 250) {
        return props.product.Description.replace(/<[^>]*>/g, '').substring(0, 250) + '...';
    }

    return props.product.Description.replace(/<[^>]*>/g, '');
})

const descriptionTooLong = computed(() => {
    if (!props.product?.Description.replace(/<[^>]*>/g, ''))
        return false;

    return props.product.Description.replace(/<[^>]*>/g, '').length > 250;
})

const contentInLiter = computed(() => {
    if (!props.product.ContentInMl)
        return null;

    let value = parseFloat(props.product.ContentInMl.toString().replace(/l|ml/g, ''));

    if (props.product.ContentInMl.toString().includes('l')) {
        value *= 1000;
    }

    // Überprüfe, ob der Wert im gültigen Bereich liegt
    if (value >= 100 && value <= 1000) {
        return (value / 1000);
    } else {
        return null;
    }
})

const pricePerLiter = computed(() => {
    if (!contentInLiter.value || (!props.product.OfferPrice && !props.product.Price))
        return null;

    const price = props.product.OfferPrice || props.product.Price;
    return price / contentInLiter.value;
});


const discount = computed(() => {
    if (!props.product.OfferPrice || !props.product.Price)
        return null;

    return Math.round((1 - (props.product.OfferPrice / props.product.Price)) * 100)
})

const baseComponentTranslations = computed(() => {
    return props.company.baseComponentTranslations;
})

const productButtonText = computed(() => {
    if(props.company.CompanyQuizConfig.ProductCardActionText)
        return props.company.CompanyQuizConfig.ProductCardActionText;

    if (
        !props.company.isIGetNowModeActive &&
        props.product.Handle &&
        props.company.CompanyQuizConfig.ResultButtonAction !==
        ResultButtonAction.SAVEMODE &&
        props.company.CompanyQuizConfig.ResultButtonAction !==
        ResultButtonAction.OPENNAVIGATIONMAP &&
        props.company.CompanyQuizConfig.ResultButtonAction !==
        ResultButtonAction.STARTTASTING &&
        props.company.CompanyQuizConfig.ResultButtonAction !==
        ResultButtonAction.EXPLOREMODE &&
        props.company.CompanyQuizConfig.ResultButtonAction !==
        ResultButtonAction.SHOWQRCODE
    )
        return isProductAvailable.value
            ? props.company.DisplayedTexts["Jetzt kaufen"]
            : props.company.DisplayedTexts["Nicht verfügbar"];
    else if (props.company.isIGetNowModeActive)
        return isProductAvailable.value
            ? props.company.DisplayedTexts["zur Karte"]
            : props.company.DisplayedTexts["Nicht verfügbar"];
    else if (
        props.company.CompanyQuizConfig.ResultButtonAction ===
        ResultButtonAction.OPENNAVIGATIONMAP
    )
        return isProductAvailable.value
            ? props.company.DisplayedTexts["Navigation öffnen"]
            : props.company.DisplayedTexts["Nicht verfügbar"];
    else if (
        props.company.CompanyQuizConfig.BTGMode
    )
        return (
            props.company.DisplayedTexts["Verkostung starten"]
        );
    else if (
        props.company.CompanyQuizConfig.ResultButtonAction ===
        ResultButtonAction.SHOWQRCODE
    )
        return props.company.DisplayedTexts["Speichern"];
    else if (
        props.company.CompanyQuizConfig.ResultButtonAction ===
        ResultButtonAction.EXPLOREMODE
    )
        return props.company.DisplayedTexts["Jetzt Entdecken"];

    return props.company.DisplayedTexts["Speichern"];
})

const isProductAvailable = computed(() => {
    return props.company.isProductAvailable(props.product);
})

const dislikeFeedbackReasons = computed(() => {
    return [
        {
            Title: props.company.DisplayedTexts["Preis"],
            Value: ProductFeedbackCause.PRICE
        },
        {
            Title: props.company.DisplayedTexts["Geschmack"],
            Value: "taste",
        },
        {
            Title: props.company.DisplayedTexts["Optik"],
            Value: "label",
        }
    ]
})

const minHeight = computed(()=>{
    if (props.company.FrontendDesign?.TextConventions?.min_height)
        return props.company.FrontendDesign.TextConventions.min_height;
    return '430px';
})

const sendFeedback = (cause?) => {
    if (cause === undefined)
        favorite.value = !favorite.value;

    if (cause === undefined && !favorite.value) return;

    if (cause !== undefined)
        dislike.value = !dislike.value;

    QuizService.sendEvent(JSON.stringify({ product: props.product.Id, wasGood: cause === undefined, cause: cause }), "ProductFeedback");
    setTimeout(() => {
        isFeedbackOverlayVisible.value = false;
        if (cause !== undefined)
            emit("productFeedbackCauseSelected", { Product: props.product, Cause: cause } as { Product: Product, Cause: ProductFeedbackCause })
    }, 2000)
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card",
      style: _normalizeStyle({minHeight: minHeight.value})
    }, [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (!isCardFlippedInner.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["cardInner", { noRadius: props.company.DisplayedTexts['border_radius'] === 'false' }]),
                onClick: flip
              }, [
                (__props.showOfferMode && discount.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, " -" + _toDisplayString(discount.value) + " % ", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  (__props.product.PictureFront)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "productImage",
                        src: __props.product.PictureFront
                      }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h4", null, _toDisplayString(__props.product.Name), 1),
                  (__props.product.TasteMatch && __props.company.CompanyQuizConfig.ShowMatchingPercentage && (__props.company.FrontendDesign?.TextConventions || {})['show_matching_on_front'] === 'true')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                        _createVNode(Favorite, { class: "icon" }),
                        _createTextVNode(" Match: " + _toDisplayString(Math.round(__props.product.TasteMatch)) + " % " + _toDisplayString(__props.company.DisplayedTexts["dein Geschmack"]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (contentInLiter.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                        _createTextVNode(_toDisplayString(contentInLiter.value) + "l ", 1),
                        (__props.product.Price)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("(1l = " + _toDisplayString(pricePerLiter.value?.toFixed(2)) + " " + _toDisplayString(__props.company.CompanyQuizConfig.CurrencySymbol ?? '€') + ") ", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.company.CompanyQuizConfig.ShowOfferMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (__props.product.OfferPrice)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.product.OfferPrice?.toFixed(2)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.product.Price?.toFixed(2)), 1)),
                        (__props.product.OfferPrice && __props.product.Price && __props.company.CompanyQuizConfig.ShowOfferMode && __props.product.OfferPrice !== __props.product.Price)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(__props.product.Price?.toFixed(2)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(__props.product.CardFrontData), (datakey) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: datakey }, [
                      (__props.product.CardFrontData[datakey])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(__props.product.CardFrontData[datakey]), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                (isFeedbackOverlayVisible.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(FeedbackOverlay, {
                        onCloseClick: _cache[0] || (_cache[0] = (e) => { e.stopPropagation(); isFeedbackOverlayVisible.value = false; dislike.value = false }),
                        onFeedbackReasonSelected: sendFeedback,
                        reasonArray: dislikeFeedbackReasons.value,
                        borderRadius: "20px",
                        company: __props.company
                      }, null, 8, ["reasonArray", "company"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (isCardFlippedInner.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["cardInner", { noRadius: props.company.DisplayedTexts['border_radius'] === 'false' }]),
                onClick: flip
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h4", null, _toDisplayString(__props.product.Name), 1),
                  (__props.product.Country || __props.product.Region)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                        _createVNode(Location, { class: "icon" }),
                        _createTextVNode(_toDisplayString(__props.product.Country) + _toDisplayString(((__props.product.Country && __props.product.Region) ? ' - ' : '') + (__props.product.Region ??
                    '')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (description.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                        _createTextVNode(_toDisplayString(description.value) + " ", 1),
                        (descriptionTooLong.value)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "link",
                              onClick: _cache[1] || (_cache[1] = (e) => { e.stopPropagation(); showDescriptionPopUp.value = true })
                            }, _toDisplayString(__props.company.DisplayedTexts["mehr anzeigen"]), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(__props.product.CardBackData), (datakey) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: datakey }, [
                      (__props.product.CardBackData[datakey])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(__props.product.CardBackData[datakey]), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  (__props.product.TasteMatch && __props.company.CompanyQuizConfig.ShowMatchingPercentage && (__props.company.FrontendDesign?.TextConventions || {})['show_matching_on_front'] !== 'true')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                        _createVNode(Favorite, { class: "icon" }),
                        _createTextVNode(" Match: " + _toDisplayString(Math.round(__props.product.TasteMatch)) + " % " + _toDisplayString(__props.company.DisplayedTexts["dein Geschmack"]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (descriptionTooLong.value && showDescriptionPopUp.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: "descriptionPopup",
                        onClick: _cache[2] || (_cache[2] = e => e.stopPropagation())
                      }, [
                        _createElementVNode("p", null, _toDisplayString(__props.product.Description), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (descriptionTooLong.value && showDescriptionPopUp.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        class: "primary desciptionPopupCloseButton",
                        onClick: _cache[3] || (_cache[3] = e => { e.stopPropagation(); showDescriptionPopUp.value = false })
                      }, _toDisplayString(__props.company.DisplayedTexts["Schließen"]), 1))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h4", null, _toDisplayString(__props.product.Name), 1),
        (__props.product.Country || __props.product.Region)
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
              _createVNode(Location, { class: "icon" }),
              _createTextVNode(_toDisplayString(__props.product.Country) + _toDisplayString((__props.product.Country ? ' - ' : '') + (__props.product.Region ?? '')), 1)
            ]))
          : _createCommentVNode("", true),
        (description.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
              _createTextVNode(_toDisplayString(description.value) + " ", 1),
              (descriptionTooLong.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "link",
                    onClick: _cache[4] || (_cache[4] = (e) => { e.stopPropagation(); showDescriptionPopUp.value = true })
                  }, _toDisplayString(__props.company.DisplayedTexts["mehr anzeigen"]), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.CardBackData, (datakey) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: datakey }, [
            (__props.product.CardBackData[datakey])
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(__props.product.CardBackData[datakey]), 1))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        (__props.product.TasteMatch && __props.company.CompanyQuizConfig.ShowMatchingPercentage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
              _createVNode(Favorite, { class: "icon" }),
              _createTextVNode(" Match: " + _toDisplayString(Math.round(__props.product.TasteMatch)) + " % " + _toDisplayString(__props.company.DisplayedTexts["dein Geschmack"]), 1)
            ]))
          : _createCommentVNode("", true),
        (descriptionTooLong.value && showDescriptionPopUp.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "descriptionPopup",
              onClick: _cache[5] || (_cache[5] = e => e.stopPropagation())
            }, [
              _createElementVNode("p", null, _toDisplayString(__props.product.Description), 1)
            ]))
          : _createCommentVNode("", true),
        (descriptionTooLong.value && showDescriptionPopUp.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              class: "primary desciptionPopupCloseButton",
              onClick: _cache[6] || (_cache[6] = e => { e.stopPropagation(); showDescriptionPopUp.value = false })
            }, _toDisplayString(__props.company.DisplayedTexts["Schließen"]), 1))
          : _createCommentVNode("", true)
      ])
    ], 4),
    (!showDescriptionPopUp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('productClicked', __props.product)))
          }, _toDisplayString(productButtonText.value) + " " + _toDisplayString(__props.stylingVariant === "CHATBOT" ? "→" : ""), 1),
          _createElementVNode("div", {
            class: "iconButton",
            style: _normalizeStyle([{"margin-right":".5em"}, {boxShadow: __props.company.FrontendDesign?.TextConventions?.userSmileys ? 'none' : ''}]),
            onClick: _cache[8] || (_cache[8] = () => { isFeedbackOverlayVisible.value = dislike.value === false; })
          }, [
            (!__props.company.FrontendDesign?.TextConventions?.userSmileys)
              ? (_openBlock(), _createBlock(SvgThumbDown, { key: 0 }))
              : (_openBlock(), _createElementBlock("span", _hoisted_24, "😕"))
          ], 4),
          _createElementVNode("div", {
            class: "iconButton",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (sendFeedback())),
            style: _normalizeStyle({ backgroundColor: favorite.value ? '#2AAC7A' : 'unset', boxShadow: __props.company.FrontendDesign?.TextConventions?.userSmileys ? 'none' : '' })
          }, [
            (!__props.company.FrontendDesign?.TextConventions?.userSmileys)
              ? (_openBlock(), _createBlock(SvgThumbUp, {
                  key: 0,
                  color: favorite.value ? 'white' : '#2AAC7A'
                }, null, 8, ["color"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_25, "😊"))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})